import { PRICING_PLANS } from './pricing';

// What everyone paid before local prices, and what anyone whose country Stripe
// cannot localise still pays
export const DOLLARS = {
  currency: 'usd',
  is_local: false,
  monthly: { price_id: PRICING_PLANS.proPackage.monthly.priceId, amount: PRICING_PLANS.proPackage.monthly.pricePerPackage },
  yearly: { price_id: PRICING_PLANS.proPackage.annual.priceId, amount: PRICING_PLANS.proPackage.annual.pricePerPackage },
  // No first-month discount since 2026-10-21: a failed request must not show one checkout does not give
  coupon: null,
  // The pack (api/services/packs.py PACK_PRICES['usd']): the first-video offer sells it beside Pro
  pack: { videos: 3, amount: 5.99, currency: 'usd', label: 'US$5.99' },
  // The Clip pack (api/services/clip_packs.py): the clipping offers sell it beside Pro
  clip_pack: { minutes: 120, remixes: 3, amount: 5.99, currency: 'usd', label: 'US$5.99' },
};

export default DOLLARS;
